export default __webpack_public_path__ + "static/media/icon-ui-construction.67023bf6.svg";